export const dockMessagesEn = {
    "dock.watchlist": "Watchlist",
    "dock.alerts": "Alerts",
    "dock.dataWindow": "Data Window",
    "dock.objectTree": "Object Tree",
    "dock.tape": "Tape",
    "dock.orderTicket": "Order Ticket",
    "dock.advisory": "Advisory",
    "dock.upgrade": "Upgrade to Pro to unlock the Dock",
    "dock.indicators": "Indicators",
    "dock.emptyPanel": "Nothing here yet",
    "dock.tradingDisabled": "Paper trading is off — enable it from the quick-trade bar",
    "dock.requiresDrawings": "Open the drawing dock to manage objects",
    "dock.requiresTape": "Needs tape data",
    "dock.requiresAdvisory": "No advisory result yet",
    "dock.requiresPaperTrading": "Enable Paper Trading to place orders",
    "dock.pin": "Pin dock",
    "dock.unpin": "Unpin dock",
    "dock.toggleRail": "Toggle dock rail",
    "dock.colLast": "Last",
    "dock.colChange": "Chg",
    "dock.colChangePct": "Chg%",
    "dock.footerRuler": "Ruler",
    "dock.footerLockAll": "Lock all",
    "dock.footerHideAll": "Hide all",
    "dock.footerTrash": "Clear all",
    "dock.footerCollapse": "Collapse",
};
